import React, { useEffect, useState } from 'react';
import { getAccount } from '../../../../../../services/settings/accounting';
import AccountDetailHeader from '../../components/accountDetailHeader';
import RecentTransactionTable from '../../components/recentTransactionTable';

export default function RecentTransaction({ setType, setLoader, loader, accountId, type }) {
	const [recentTransactionList, setRecentTransactionList] = useState([]);
	const [accountName, setAccountName] = useState('');
	const columns = [
		{
			key: 'date',
			label: 'DATE',
		},
		{
			key: 'party_name',
			label: 'TRANSACTION DETAILS',
		},
		{
			key: 'type',
			label: 'TYPE',
		},
		{
			key: 'debit',
			label: 'DEBIT',
		},
		{
			key: 'credit',
			label: 'CREDIT',
		},
		{
			key: 'reference',
			label: 'REFERENCE',
		},
	];
	const getAccountDetails = async () => {
		try {
			setLoader(true);
			const data = await getAccount(accountId);
			setAccountName(data?.account_name);
			if (data.recent_transactions && data.recent_transactions.length > 0) {
				setRecentTransactionList(data.recent_transactions);
			} else {
				setRecentTransactionList([]);
			}
		} catch (e) {
		} finally {
			setLoader(false);
		}
	};

	useEffect(() => {
		if (accountId) {
			getAccountDetails();
		}
	}, [accountId]);
	return (
		<div>
			<div
				className="bg-white"
				style={{ height: 'calc(100vh - 60px' }}
			>
				<AccountDetailHeader
					setIsOpenAccount={() => {}}
					setIsOpenActivateAccountModal={() => {}}
					setIsOpenDeactivateAccountModal={() => {}}
					setAccountId={() => {}}
					setType={setType}
					type={type}
					getList={() => {}}
					status={''}
					accountName={accountName}
					accountType={'Recent Transaction'}
					highlistText={'See all the transactions under this account.'}
				/>
				<div className="px-3 py-4">
					<RecentTransactionTable
						columns={columns}
						row={recentTransactionList}
						style={{ height: 'calc(100vh - 185px)' }}
					/>
				</div>
			</div>
		</div>
	);
}
